import React from "react";
import "./notice.scss";
function Notice({ text, status = "success" }) {
  const classes = `grigora-notice status-${status}`;

  return <div className={classes}>{text}</div>;
}

export default Notice;
